<template>
	<v-container fill-height fluid>
		<v-row>
			<v-col cols="6" class="pa-0">
				<AuthSidebar/>
			</v-col>
			<v-col cols="6" class="pa-0">
				<div class="right-section ">
					<v-row no-gutters>
						<v-col cols="10" class="text-right"></v-col>
						<v-col cols="2">
							<LanguageSelection class="float-right" />
						</v-col>
					</v-row>
          			<div class="flex-direction-box">
            			<div class="login-from vertical-center">
							<h2>{{ $t("login.welcome") }}</h2>
							<p class="gray--text">{{ $t("login.welInfo") }}</p>
							<form @submit.prevent="checkAuth">
								<div class="login-from-fill">
									<div class="form-group">
										<v-text-field
										outlined
										v-model.trim="username"
										prepend-inner-icon="mdi-account"
										:error-messages="errors.username"
										:placeholder="$t('login.emailMobile')"
										></v-text-field>
									</div>
									<div class="form-group">
										<v-text-field
										:type="passwordType"
										outlined
										v-model.trim="password"
										prepend-inner-icon="mdi-lock-outline"
										:append-icon="passwordIcon"
										:error-messages="errors.password"
										@click:append="changePasswordType"
										:placeholder="$t('password') + '*'"
										></v-text-field>
									</div>
				  					<v-row>
										<!-- <v-col cols="5">
											<router-link class="forget primary--text" color="Primary" to="/forgot-password">Forgot Password?</router-link>
										</v-col> -->
										<v-col cols="5" class="float-right">
											<router-link class="forget primary--text float-right" color="Primary" to="/register">{{ $t('login.register') }}</router-link>
										</v-col>
									</v-row>
									<v-btn type="submit" block color="primary" class="mt-5">{{ $t("login.login") }}</v-btn>
								</div>
							</form>
						</div>
					</div>
				</div>
			</v-col>
    	</v-row>
  	</v-container>
</template>

<script>
import loading from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";

import AuthSidebar from "./AuthSidebar.vue"
  export default {
	components: {
		AuthSidebar
	},
	computed: {
		isAuthErr() {
			return this.authErr.length > 0;
		}
	},
	async mounted() {
		document.title = this.$t('login.login');
	},
    data() {
      return {
		error: false,
		errors: { username : '', password: ''},
        username: '',
        password: '',
		passwordType: 'password',
		passwordIcon: 'mdi-eye',
		authErr: ''
      }
    },
    methods: {
		changePasswordType() {
			console.log('test')
			if(this.passwordType == 'password'){
				this.passwordType = 'text';
				this.passwordIcon = 'mdi-eye-off'
			}else{
				this.passwordType = 'password';
				this.passwordIcon = 'mdi-eye'
			}
		},
      	async checkAuth() {
		  	this.startLoading();
			this.emptyErrors();
		  	// form Validations 
			if(!this.validForm()){
				this.stopLoading();
				return false;
			}
		  	// form validations end
		  	const authData = {
			  	credential: this.username,
			  	password: this.password
		  	}
			try{
				await this.$store.dispatch('checkAuth', authData);
				this.stopLoading();
			 	this.$router.replace({name: 'My farm'});
			}catch(error) {
				// console.log('ee',error);
				// this.authErr = error;
				this.$notify({
					title: this.$t('login.unableToLogin'),
					text: error,
					type: 'error'
				});
				this.stopLoading();
			}
      	},
		emptyErrors(){
			this.error = false;
			this.errors.username = '';
			this.errors.password = '';
			this.authErr = '';
		},
		
		validForm() {
			if(this.username == ''){
				this.errors.username = this.$t("login.emailMobileCannotEmpty");
				this.error = true;
			}else if(!this.validateEmail(this.username) && (!this.validMobileNumber(this.username))){
				this.errors.username = this.$t('login.invalidEmailMobileFormat');
				this.error = true;
			}
			if(this.password == ''){
				this.errors.password = this.$t('login.passwordCannotEmpty');
				this.error = true;
			}else if(this.password.length < 5) {
				this.errors.password = this.$t('login.passwordLengthCanlessthan8');
				this.error = true;
			}
			if(this.error)
				return false;

			return true;
		}
    },
    mixins: [loading, generalMixin]
  };
</script>

<style scoped lang="scss">



.right-section {
	padding: 6px 20px;
	background-color: white;
	height: 100vh;
}
.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.right-section .login-details {
	text-align: end;
}
.right-section .login-details h2 {
	font-size: 14px;
	font-family: pop_regular;
	font-weight: 100;
}
.right-section .login-details h2 a {
	color: #AABDCF;
	font-family: pop_semiBold;
	text-decoration: none;
	margin-left: 4px;
}
.right-section .login-from h2{
	font-size:30px;
	font-family: pop_semiBold;
	font-weight: 600;
	margin-bottom: 0px
}
.right-section .login-from p{
	color:#AABDCF;
	font-size: 12px;
	font-family: pop_regular;
	width: 308px;
	margin-top: 3px;
}
.flex-direction-box {
	height: 546px;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.login-from-fill label {
	display: inline-block;
	margin-bottom: .5rem;
	color: #97A8B8;
	font-size: 14px;
	font-family: Poppins-Medium;
	letter-spacing: 0.5px;  
}
.login-from-fill .form-control {
	display: block;
	width: 100%;
	height: calc(1.5em + .75rem + 2px);
	padding: .375rem .75rem;
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5;
	color: #495057;
	transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
	background: #E7F0F8;
	border: 1px solid #C7D5E1;
	border-radius: 3px;
}
.login-from-fill {
	margin-top: 31px;
}

.login-from-fill .forget{
	font-size: 14px;
	font-family: Poppins-Medium;
	text-decoration: none;
	display: block;
	margin-top: 9px;
}


/*forgot css*/
.login-from-fill .form-group.phone-number {
	display: flex;
}
.login-from-fill .number-list {
	width: 52px;
	padding: 6px 4px;
	border-radius: 3px 0px 0px 3px;
	background: #AABDCF;
	color: #fff;
	font-size: 13px;
	height: 38px;
	border: 0px;
}
.login-from-fill .form-control.phone-control {
	margin: 0px;
	border-radius: 0px 3px 3px 0px;
}
select:focus-visible {
	outline: none;
}
input.form-control:focus-visible {
	outline: none;
}
.form-control::placeholder{
	font-size: 13px;
	font-family: pop_regular;
}
.login-from .emailgroup .form-control::placeholder{
	font-size: 13px;
	font-family: pop_semiBold;
}

</style>
